import React from 'react'
import { connect } from 'react-redux'
import { openModal, closeModal } from '../../state/actions'


class Modal extends React.PureComponent {

  componentWillMount(){
    this.props.openModal()
  }

  componentWillUnmount(){
    this.props.closeModal()
  }

  render(){
    const { close } = this.props
    return (
      <div className="vh-100 dt w-100 viz-modal" onClick={close}>
        <div className="viz-modal-body h-container" onClick={e => e.stopPropagation()}>
          <div className="dib viz-modal-close pointer" onClick={close}>x</div>
          <div className="h-100" style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
            { this.props.children }
          </div>
        </div>
      </div>
    )
  }
}


const mapDispatchToProps = {
  openModal, closeModal
}

export default connect(undefined, mapDispatchToProps)(Modal)



// WEBPACK FOOTER //
// ./src/components/Modal/index.js